import { render } from "./ImageCarousel.vue?vue&type=template&id=367701ac&scoped=true&ts=true"
import script from "./ImageCarousel.vue?vue&type=script&lang=ts"
export * from "./ImageCarousel.vue?vue&type=script&lang=ts"

import "./ImageCarousel.vue?vue&type=style&index=0&id=367701ac&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-367701ac"]])

export default __exports__